/**
 * Updates the recently viewed products in localStorage.
 */
export class RecentlyViewed {
  /** @static @constant {string} The key used to store the viewed products in session storage */
  static #STORAGE_KEY = 'viewedProducts';
  /** @static @constant {number} The maximum number of products to store */
  static #MAX_PRODUCTS = 4;

  /**
   * Adds a product to the recently viewed products list.
   * @param {string|object} productId - The ID of the product to add, or product object.
   */
  static addProduct(productId) {
    // Handle both product ID string and product object
    const id = typeof productId === 'string' ? productId : productId?.id;
    if (!id) return;

    let viewedProducts = this.getProducts();

    viewedProducts = viewedProducts.filter((/** @type {string} */ id) => id !== productId);
    viewedProducts.unshift(id);
    viewedProducts = viewedProducts.slice(0, this.#MAX_PRODUCTS);

    localStorage.setItem(this.#STORAGE_KEY, JSON.stringify(viewedProducts));
  }

  static clearProducts() {
    localStorage.removeItem(this.#STORAGE_KEY);
  }

  /**
   * Retrieves the list of recently viewed products from session storage.
   * @returns {string[]} The list of viewed products.
   */
  static getProducts() {
    return JSON.parse(localStorage.getItem(this.#STORAGE_KEY) || '[]');
  }
}


// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', function() {
  // Keep this for backward compatibility
});

// Also initialize on page navigation (for SPA-like behavior)
document.addEventListener('shopify:section:load', function() {
  // Keep this for backward compatibility
});